(() => {
  const process = (button, open = true) => {
    const targetIds = button.getAttribute('aria-controls').split(' ');

    targetIds.forEach((targetId) => {
      const target = document.getElementById(targetId);

      document
        .querySelectorAll(`[aria-controls~="${targetId}"]`)
        .forEach((button) => {
          button.setAttribute('aria-expanded', open ? 'true' : 'false');
        });

      if (!target) {
        return;
      }

      if (!open) {
        window.swinger.visibility.hide(target);
      } else {
        window.swinger.visibility.show(target);
      }
    });
  };

  /*
  We delay the following by 100 ms to enable more specific script to pull ahead
  and to stop this script applying itself to a toggle via e.stopImmediatePropagation()
  e.g. the header script for toggling the menu
   */
  const handleEvent = (e) => {
    const button = window.swinger.eventHub.getTarget(e).closest('[aria-controls][aria-expanded]');
    const groupToggle = !!button.getAttribute('data-group-toggle');

    if (button.getAttribute('aria-expanded') === 'false') {
      process(button, true);
    } else {
      process(button, false);
    }

    if (groupToggle && button.className) {
      const selector = button.className.split(' ').filter((className) => !!className.trim()).map((cn) => `.${cn.trim()}`).join('');
      const buttonsToClose = window.swinger.$(`${selector}[aria-expanded="true"]`).filter((elem) => elem !== button);

      buttonsToClose.forEach((button) => process(button, false));
    }

    if (window.swinger.eventHub) {
      window.swinger.eventHub.trigger(button, 'swinger.aria-expanded-toggle:toggle');
    }

    e.preventDefault();
  };

  const triggerEvent = (e) => {
    if (e.type === 'keydown' && e.key !== ' ') {
      return;
    }

    const elem = window.swinger.eventHub.getTarget(e).closest('button[aria-controls][aria-expanded],[role="button"][aria-controls][aria-expanded]');

    if (!elem) {
      return;
    }

    if (elem.closest('.plyr')) {
      return;
    }

    handleEvent(e);

    if (elem.matches('[href^="#"]')) {
      const idSelector = elem.getAttribute('href');
      try {
        const targetElem = document.querySelector(idSelector);
        targetElem.focus();
      } catch (e) {
        // noop
      }
    }

    e.preventDefault();
  };

  window.setTimeout(() => {
    document.addEventListener('keydown', triggerEvent, true);
    document.addEventListener('click', triggerEvent, true);
  }, 100);

  window.swinger.observer.initialize('[data-aria-controls]', (controllingElement) => {
    const ariaControlsId = controllingElement.getAttribute('data-aria-controls');

    window.swinger.observer.initialize(`#${ariaControlsId}`, (controlledElement) => {
      controllingElement.setAttribute('role', 'button');
      controllingElement.setAttribute('aria-controls', ariaControlsId);
      controllingElement.setAttribute('aria-expanded', 'false');

      switch (true) {
        default:
          break;

        case controlledElement.matches('dialog,[role="dialog"]'):
          controllingElement.setAttribute('aria-haspopup', 'dialog');
          controlledElement.setAttribute('aria-hidden', 'true');
          controlledElement.setAttribute('inert', '');
          break;
      }

      window.swinger.visibility.observe(controlledElement, (visible) => {
        controllingElement.setAttribute('aria-expanded', visible.toString());

        if (controlledElement.matches('div')) {
          controlledElement.setAttribute('aria-hidden', visible ? 'false' : 'true');
          controlledElement[visible ? 'removeAttribute' : 'setAttribute']('inert', '');
        }
      });
    }, false);
  }, false);
})();
